<template>
  <div class="power-effect">
    <div>
      <span class="trend-title1">各类成效</span>
      <div class="power-effect-any">
        <span class="trend-title">资金</span>
        <el-input type="text" placeholder="请输入" v-model="money"></el-input>
        <span class="trend-title">效率</span>
        <el-input type="text" placeholder="请输入" v-model="effect"></el-input>
        <span class="trend-title">安全</span>
        <el-input type="text" placeholder="请输入" v-model="save"></el-input>
        <span class="trend-title">单位能耗降低</span>
        <el-input type="text" placeholder="请输入" v-model="unitPower"></el-input>
        <span class="trend-title">社会价值</span>
        <el-input type="text" placeholder="请输入" v-model="socialValue"></el-input>
      </div>
    </div>
    <div style=" margin-top: 3rem;">
      <span class="trend-title1">历年总成效</span>
      <el-button @click="addEffect" style="margin:0 0 20px 20px" size="small" type="success" icon="el-icon-plus">添加</el-button>
    </div>
    <div class="save-box">
      <!-- <div>
        <span style="border-right:1px solid #0e83d1;width:10%" class="trend-title">年份</span>
        <span style="width:10%" class="trend-title">产生效益金额</span>
      </div> -->
      <div v-for="(msg,index) in effectDate" :key="index" class="power-effect-year">
        <el-date-picker
          value-format="yyyy"
          v-model="msg.energyYear"
          type="year"
          placeholder="选择日期时间">
        </el-date-picker>
        <el-input type="number" placeholder="请输入" v-model="msg.fundIncom">
           <template slot="suffix">万元</template>
        </el-input>
        <el-button @click="removeEffect(msg.id,index)" size="small" type="danger" icon="el-icon-minus">删除</el-button>
      </div>
    </div>
    <div class="last-save" style="margin-top:2rem;">
      <el-button :loading="effectLoading" size="small" @click="saveEffect" type="primary">保存</el-button>
    </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      effectLoading:false,//加载状态
      linshiID:'',//id
      money:'',//资金
      effect:'',//效率
      save:'',//安全
      unitPower:'',//单位能耗降低
      socialValue:'',//社会价值
      effectDate:[],
    }
  },
  mounted(){
    this.getEffect()
  },
  methods:{
    //保存数据
    saveEffect(){
      this.effectLoading = true;
      let obj = {}
      obj.years = this.effectDate
      obj.income = {
        effIncome:this.effect,
        energyIncome:this.unitPower,
        fundIncom:this.money,
        safeIncome:this.save,
        socialIncome:this.socialValue,
        energyYear:new Date().getFullYear()
      }
      if(this.linshiID){
        obj.income.id = this.linshiID
      }
      apis.saveIncome(obj).then(res=>{
        if(res.code==10000){
          this.effectLoading = false;
          this.getEffect()
          this.$message.success('保存成功')
        }else{
          this.$message.error(res.message)
          this.effectLoading = false;
          return;
        }
      })
    },
    //获取数据
    getEffect(){
      //列表
      apis.getIncome({year:''}).then(res=>{
        if(res.code==10000){
          if(res.data.length!=0){
            this.effectDate = (res.data).reverse()
          }else{
            this.effectDate = []
          }
        }
      })
      //各项投入
      apis.getIncomeZB().then(res=>{
        if(res.code==10000){
          this.money = res.data[0].fundIncom
          this.effect = res.data[0].effIncome
          this.unitPower = res.data[0].energyIncome
          this.save = res.data[0].safeIncome
          this.socialValue = res.data[0].socialIncome
          this.linshiID = res.data[0].id
        }
      })
    },
    //添加一行成效
    addEffect(){
      this.effectDate.push({energyYear:'',fundIncom:''})
    },
    //删除一行成效
    removeEffect(id,index){
      if(id){
        this.$confirm('确认删除, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apis.delIncome([id]).then(res=>{
            if(res.code==10000){
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              this.getEffect()
            }else{
              this.$message.error(res.message);
              return;
            }
          })
        })
      }else{
        this.effectDate.splice(index,1)
      }
    },
  }
}
</script>
<style lang="less" scoped>
.power-effect{
  .trend-title1{ font-weight: bold; color: #24ffb1; font-size: .9rem; padding-left: 10px; border-left: #24ffb1 solid 5px; display: inline-block; margin: .4rem 0 .6rem;}
  .power-effect-any{
    .trend-title{ width: 7rem;}
    .el-input,.el-select{ width: 8rem;}
  }
  .save-box{
    .power-effect-year{ margin-bottom: 15px;}
    .el-input,.el-select{ width: 10rem;}
  }
}
</style>